import { createSlice } from "@reduxjs/toolkit"
import { createCustomAsyncThunk, defaultEntityAdapter } from "./utils"
import { taskService } from "../services/lessonService"
import React from "react"
import { useDispatch, useSelector } from "react-redux"

export const getTasks = createCustomAsyncThunk(
    "tasks/get",
    async params => await taskService.get(params)
)

export const createTask = createCustomAsyncThunk(
    "tasks/create",
    async data => await taskService.post(data)
)

export const updateTask = createCustomAsyncThunk(
    "tasks/update",
    async data => await taskService.patch(data)
)

export const addTaskFiles = createCustomAsyncThunk(
    "tasks/addFiles",
    async data => await taskService.addFile(data)
)

const taskSlice = createSlice({
    name: "tasks",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null,
    }),
    extraReducers: builder => {
        builder
            .addCase(getTasks.pending, state => { state.isLoading = true })
            .addCase(getTasks.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getTasks.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(createTask.pending, state => { state.isLoading = true })
            .addCase(createTask.fulfilled, (state, action) => {
                defaultEntityAdapter.addOne(state, action.payload)
                state.isLoading = false
            })
            .addCase(createTask.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(updateTask.pending, state => { state.isLoading = true })
            .addCase(updateTask.fulfilled, (state, action) => {
                defaultEntityAdapter.upsertOne(state, action.payload)
                state.isLoading = false
            })
            .addCase(updateTask.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(addTaskFiles.pending, state => { state.isLoading = true })
            .addCase(addTaskFiles.fulfilled, (state, action) => {
                defaultEntityAdapter.upsertOne(state, action.payload)
                state.isLoading = false
            })
            .addCase(addTaskFiles.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})

export default taskSlice.reducer

export const taskSelectors = defaultEntityAdapter.getSelectors(x => x.tasks)

export const useTasks = (lesson, role, id) => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (lesson?.id && role && id) {
            dispatch(getTasks({ lesson: lesson.id, role: id }))
        }
    }, [dispatch, lesson, role, id])

    const tasks = useSelector(taskSelectors.selectAll)
    const tasksIsLoading = useSelector(x => x.tasks.isLoading)

    return { tasks, tasksIsLoading }
}

export const useTasksByLesson = lesson => {
    const dispatch = useDispatch()

    React.useEffect(() => {
        if (lesson?.id) {
            dispatch(getTasks({ lesson: lesson.id }))
        }
    }, [dispatch, lesson])

    const tasks = useSelector(taskSelectors.selectAll)
    const tasksIsLoading = useSelector(x => x.tasks.isLoading)

    return { tasks, tasksIsLoading }
}